import { render } from "./elem-options.vue?vue&type=template&id=b3c8a2e4&ts=true"
import script from "./elem-options.vue?vue&type=script&lang=ts"
export * from "./elem-options.vue?vue&type=script&lang=ts"

import "./elem-options.vue?vue&type=style&index=0&id=b3c8a2e4&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__